import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  createFormatTimestamp,
  type FormatTimestamp
} from './createFormatTimestamp';

/** Locale-aware timestamp formatting via the active i18n language. */
export function useFormatTimestamp(): FormatTimestamp {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  return useMemo(() => createFormatTimestamp(locale), [locale]);
}
